import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import moment from 'moment';
import Detail from './details/index.vue';

var HwcStatement = function (_super) {
  __extends(HwcStatement, _super);

  function HwcStatement() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.orderListEsPoint = null;
    _this.loadingStatus = false;
    _this.columns = [];
    _this.rowSelection = {};
    _this.warehouseList = [];
    _this.logisticsList = [];
    _this.selectedList = [];
    _this.detailsVisible = false;
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition(180);
    _this.rowData = {};
    _this.dsCodeListEnum = [];
    _this.orderTypeList = [{
      value: 1,
      text: _this.t('FBA订单')
    }, {
      value: 2,
      text: _this.t('标准订单')
    }, {
      value: 3,
      text: _this.t('自提订单')
    }, {
      value: 4,
      text: _this.t('销毁订单')
    }];
    _this.codeTypeEnum = [];
    _this.timeTypeEnum = [];
    return _this;
  }

  HwcStatement.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.time_start = this.$util.formatDateTime(arr[0]);
      this.searchData.time_end = this.$util.formatDateTime(arr[1]);
    } else {
      this.datetimeDefaultValue = [moment(this.searchData.time_start), moment(this.searchData.time_end)];
    }
  };

  HwcStatement.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('单号'),
      name: 'order_number',
      dataIndex: 'order_number',
      filterEmpty: true,
      disabled: true,
      isCopy: true
    }, {
      title: this.t('参考号'),
      dataIndex: 'reference_number',
      name: 'reference_number',
      filterEmpty: true,
      isCopy: true,
      disabled: true
    }, {
      title: this.t('跟踪号'),
      dataIndex: 'track_number',
      filterEmpty: true,
      name: 'track_number',
      isCopy: true
    }, {
      title: this.t('单据类型'),
      dataIndex: 'business_type_text',
      name: 'business_type_text',
      filterEmpty: true
    }, {
      title: this.t('订单类型'),
      dataIndex: 'order_type_text',
      checked: false,
      name: 'order_type_text',
      filterEmpty: true
    }, {
      title: this.t('仓库'),
      dataIndex: 'regional_warehouse_code',
      scopedSlots: {
        customRender: 'regional_warehouse_code'
      },
      name: 'regional_warehouse_code'
    }, {
      title: this.t('物流方式'),
      dataIndex: 'product_name_cn',
      name: 'product_name_cn',
      filterEmpty: true,
      isCopy: true,
      disabled: true
    }, {
      title: this.t('总费用'),
      dataIndex: 'total_amount_list',
      name: 'total_amount_list',
      align: 'right',
      scopedSlots: {
        customRender: 'total_amount_list'
      },
      disabled: true
    }, {
      title: this.t('创建时间'),
      dataIndex: 'order_create_time',
      name: 'order_create_time',
      filterEmpty: true
    }, {
      title: this.t('更新时间'),
      dataIndex: 'update_time',
      name: 'update_time',
      disabled: true,
      filterEmpty: true
    }, {
      title: this.t('操作'),
      key: 'operation',
      width: 80,
      fixed: 'right',
      showColumnSetting: true,
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, selectedRows) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
        var pendingConfirmList = [];
      }
    };
    this.$nextTick(function () {
      _this.queryHwcStatementList();
    });
    this.queryWarehouseList();
    this.getAllLogisticsList({
      type: this.$enum.warehouse.CustomerWarehouseTypeEnum.SHIPPING
    });
  };

  HwcStatement.prototype.queryHwcStatementList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            this.total = null;
            return [4, this.$api.finance.queryHwcStatementList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.searchData.search_after_id = data.next_token;
            this.searchData.search_before_id = data.prev_token;
            this.orderListEsPoint = data.list_es_point;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  HwcStatement.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  HwcStatement.prototype.getAllLogisticsList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.logisticsList = [];
            return [4, this.$api.common.getAllLogisticsList(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.logisticsList = res.data;
            }

            return [2];
        }
      });
    });
  };

  HwcStatement.prototype.handleDetail = function (record) {
    this.rowData = record;
    this.detailsVisible = true;
  };

  HwcStatement.prototype.getInitSearchData = function () {
    return {
      code_field: this.$enum.finance.HwcStatementNewFieldEnum.CODE,
      code_value: undefined,
      product_code: undefined,
      business_type: undefined,
      order_type: undefined,
      regional_warehouse_code: undefined,
      time_field: this.$enum.finance.HwcStatementTimeFieldEnum.CREATE_TIME,
      time_start: '',
      time_end: '',
      page_index: 1,
      page_size: 10
    };
  };

  HwcStatement.prototype.handlePageChange = function (page) {
    if (page > this.searchData.page_index) {
      delete this.searchData.search_before_id;
    } else if (page < this.searchData.page_index) {
      delete this.searchData.search_after_id;
    } else {
      delete this.searchData.search_before_id;
      delete this.searchData.search_after_id;
    }

    this.searchData.page_index = page;
    this.queryHwcStatementList();
  };

  HwcStatement.prototype.initPage = function () {
    this.searchData.page_index = 1;
    this.selectedList = [];
    this.rowSelection.selectedRowKeys = [];
  };

  HwcStatement.prototype.handleSearch = function () {
    this.initPage();
    this.queryHwcStatementList();
  };

  HwcStatement.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.initPage();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(180);
    this.$nextTick(function () {
      return _this.queryHwcStatementList();
    });
  };

  HwcStatement.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData.order_number_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData.order_number_list = this.selectedList;
            }

            return [4, this.$api.finance.queryHwcStatementExport(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  __decorate([enumData('Finance/DsCodeListEnum')], HwcStatement.prototype, "dsCodeListEnum", void 0);

  __decorate([enumData('Finance/HwcStatementNewFieldEnum')], HwcStatement.prototype, "codeTypeEnum", void 0);

  __decorate([enumData('Finance/HwcStatementTimeFieldEnum')], HwcStatement.prototype, "timeTypeEnum", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], HwcStatement.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], HwcStatement.prototype, "queryHwcStatementList", null);

  __decorate([userPrefPageSize('hwcStatementList')], HwcStatement.prototype, "getInitSearchData", null);

  HwcStatement = __decorate([Component({
    components: {
      Detail: Detail
    }
  })], HwcStatement);
  return HwcStatement;
}(Vue);

export default HwcStatement;